module.exports = __webpack_public_path__ + "resources/img/solution_game_logo_ateam.14392bcc740bf1f7a2088f26c7c90744.png";